// extracted by mini-css-extract-plugin
export default {"heroBase":"styles_heroBase__tGfsr","heroWalky":"styles_heroWalky__dP3QH","hero":"styles_hero__9zRzj","title":"styles_title__dJUmF","cta":"styles_cta__mb6Es"};